import currencyService from '../../services/currencyService'

const state = {
  currencies: [],
  currenciesPage: 1,
  currenciesTotal: 0,
}

const getters = {
  getCurrenciesTotal: (state) => state.currenciesTotal,
  getCurrencies: (state) => (page) => {
    return (page === state.currenciesPage) ? state.currencies : []
  },
}

const mutations = {
  setCurrencies(state, {currencies, total, page}) {
    state.currencies = currencies
    state.currenciesTotal = total
    state.currenciesPage = page
  },
  deleteCurrency(state, payload) {
    const index = state.currencies.findIndex(currencies => currencies.id === payload)
    if (index > -1) {
      state.currencies.splice(index, 1)
    }
  },
}

const actions = {
  getCurrencies({ commit }, {page, itemsPerPage}) {
    page = page || 1
    const limit = itemsPerPage || 20
    const offset = limit * (page - 1)

    return currencyService.getCurrencies(offset, limit)
      .then(({currencies, total}) => {
        commit('setCurrencies', {currencies, total, page})
        return {currencies, total}
      })
      .catch(errObj => Promise.reject(errObj))
  },
  deleteCurrency({ commit }, id) {
    return currencyService.deleteCurrency(id)
      .then(() => {
        commit('deleteCurrency', id)
        return true
      })
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/-service-app/store/modules/currenciesStore.js